<template>
  <origins-form
    id="0"
    :distribution-id="distributionId"
    @submit="addOrigin"
    @close="onClose"
  />
</template>
<script>
import OriginsForm from './OriginsForm.vue'

export default {
  name: 'CreateOrigin',
  components: {
    OriginsForm,
  },
  data() {
    return {
      distributionId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
  },
  methods: {
    addOrigin(origin) {
      this.$store.dispatch('cdn/addOrigin', origin).then(() => {
        this.successToast('Origin was added')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating origin.') })
    },

    onClose() {
      this.$router.push({ name: 'distribution-origins', params: { id: this.distributionId } })
    },
  },
}
</script>
